import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { FaAngleRight } from "react-icons/fa";
import { FaAngleLeft } from "react-icons/fa";

export default function CategoriesAccordion({
  category,
  categoriesFilter,
  setCategoriesFilter,
}) {
  const [open, setOpen] = useState(false);
  const { t, i18n } = useTranslation();

  const handleCategoryToggle = (category) => {
    const isParent = category.children && category.children.length > 0;
    const categoryId = category.id;

    if (isParent) {
      const isParentSelected = categoriesFilter.includes(categoryId);

      if (isParentSelected) {
        const idsToRemove = [
          categoryId,
          ...category.children.map((child) => child.id),
        ];
        setCategoriesFilter((prev) =>
          prev.filter((id) => !idsToRemove.includes(id))
        );
      } else {
        const idsToAdd = [
          categoryId,
          ...category.children.map((child) => child.id),
        ];
        setCategoriesFilter((prev) => [...new Set([...prev, ...idsToAdd])]);
      }
    } else {
      const isChildSelected = categoriesFilter.includes(categoryId);

      if (isChildSelected) {
        setCategoriesFilter((prev) => prev.filter((id) => id !== categoryId));
      } else {
        setCategoriesFilter((prev) => [...prev, categoryId]);
      }
    }
  };

  return (
    <>
      <li
        onClick={() => setOpen(!open)}
        className="d-flex justify-content-between align-items-center"
        style={{ cursor: "pointer" }}
      >
        <div className="d-flex align-items-center gap-2 capitalize">
          {category?.children?.find((child) =>
            categoriesFilter.includes(child?.id)
          ) && (
            <span
              className="bg-primary"
              style={{ borderRadius: "50%", width: "10px", height: "10px" }}
            ></span>
          )}
          {i18n.language === "ar" ? category?.name : category?.name_en}{" "}
        </div>
        {i18n.language === "ar" ? (
          <FaAngleRight style={{ rotate: open ? "90deg" : "0deg" }} />
        ) : (
          <FaAngleLeft style={{ rotate: open ? "-90deg" : "0deg" }} />
        )}
      </li>

      {open && (
        <ul className="mb-3">
          <li>
            <div className="sidebar-widget-list-left capitalize">
              <button
                className={`${
                  categoriesFilter.includes(category?.id) ? "active" : ""
                }`}
                onClick={(e) => {
                  handleCategoryToggle(category);
                }}
              >
                {" "}
                <span className="checkmark" />
                {t("all")} {t("products")}
              </button>
            </div>
          </li>
          {category?.children?.map((child) => (
            <li key={child?.id}>
              <div className="sidebar-widget-list-left">
                <button
                  className={`${
                    categoriesFilter.includes(child?.id) ? "active" : ""
                  }`}
                  onClick={(e) => {
                    handleCategoryToggle(child);
                  }}
                >
                  {" "}
                  <span className="checkmark" />
                  {i18n.language === "ar" ? child?.name : child?.name_en}{" "}
                </button>
              </div>
            </li>
          ))}
        </ul>
      )}
    </>
  );
}
